import { generateGuid } from '@notes/webintegrations-common'

let deviceID: string | undefined

export function localStorageAvailable(): boolean {
  try {
    const storageTest = 'tniStorageTest'
    localStorage.setItem(storageTest, storageTest)
    localStorage.removeItem(storageTest)
    return true
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.info('[getDeviceID] local storage unavailable')
    return false
  }
}

export function getDeviceID(): string {
  const deviceIdKey = 'snDeviceId'
  // tslint:disable-next-line:no-typeof-undefined
  if (typeof(deviceID) === 'undefined') {
    if (localStorageAvailable()) {
      const existingDeviceId = localStorage.getItem(deviceIdKey)
      if (!existingDeviceId) {
        deviceID = generateGuid()
        localStorage.setItem(deviceIdKey, deviceID)
      } else {
        deviceID = existingDeviceId
      }
    } else {
      deviceID = generateGuid()
    }
  }

  return deviceID
}

export function overrideDeviceID(id: string): void {
  deviceID = id
}
